module.exports = __webpack_public_path__ + "img/Finland.c53d6923.png";